import { Observable } from 'rxjs';
import { Receipt, ReceiptType } from './model';

export abstract class ReceiptRepository {
  abstract createReceipt(receipt: Partial<Receipt>): Observable<Receipt>;
  abstract getReceipt(id: number): Observable<Receipt>;
  abstract getReceipts(page: number, limit: number): Observable<Receipt[]>;
  abstract updateReceipt(id: number, receipt: Partial<Receipt>): Observable<Receipt>;
  abstract deleteReceipt(id: number): Observable<void>;

  abstract createReceiptType(receiptType: Partial<ReceiptType>): Observable<ReceiptType>;
  abstract getReceiptType(id: number): Observable<ReceiptType>;
  abstract getReceiptTypes(page: number, limit: number): Observable<ReceiptType[]>;
  abstract updateReceiptType(id: number, receiptType: Partial<ReceiptType>): Observable<ReceiptType>;
  abstract deleteReceiptType(id: number): Observable<void>;
}
